import Link from "next/link";
import { classNames } from "../utils/formatters";
import { ReactNode } from "react";

type ButtonProps = {
  link: string;
  text: string;
  className?: string;
  children?: ReactNode;
};

export default function Button({
  link,
  text,
  className,
  children,
}: ButtonProps) {
  const baseClassNames =
    "inline-flex gap-x-1 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50";
  return (
    <div className="max-w-3xl m-auto mt-5">
      <Link href={link}>
        <button className={classNames(baseClassNames, className)}>
          {children} {text}
        </button>
      </Link>
    </div>
  );
}
